import React, { useRef, useState } from 'react';
import { Flex, Text, Input, Button } from '@chakra-ui/react';
import Locale from '../../utils/translations';

interface AudioFileInputProps {
	label?: string;
	onFileSelect: (file: File) => void;
	accept?: string;
}

const AudioFileInput: React.FC<AudioFileInputProps> = ({
	label,
	onFileSelect,
	accept = '.mp3,.wav',
}) => {
	const inputRef = useRef<HTMLInputElement>(null);
	const [fileName, setFileName] = useState<string>('');

	const handleButtonClick = () => {
		inputRef.current?.click();
	};

	return (
		<Flex flexDirection="column">
			<Text mb={3} fontSize={14} fontWeight="bold" color="black">
				{label || Locale.get('Audio file (.mp3, .wav)')}
			</Text>
			<Button
				size="sm"
				onClick={handleButtonClick}
				mb={2}
				variant="bePrimary"
				bg="gray.200"
				color="black"
				_hover={{ bg: 'gray.300' }}
				width="fit-content"
				minW="140px"
				px={4}
				border={'1px solid'}
			>
				{Locale.get('Choose File')}
			</Button>
			<Input
				ref={inputRef}
				type="file"
				display="none"
				accept={accept}
				onChange={e => {
					const file = e.target.files?.[0];
					if (file) {
						setFileName(file.name);
						onFileSelect(file);
					}
				}}
			/>
			{fileName && (
				<Text fontSize={13} color="black" bg="gray.100" p={2} borderRadius="md" mt={1}>
					{fileName}
				</Text>
			)}
		</Flex>
	);
};

export default AudioFileInput;
